import React from 'react';
import { useIntl } from 'react-intl';

import QuizStudentWrapper, { QUIZ_STUDENT_THEME } from '../__wrapper/quiz-student__wrapper';
import { UI_KIT_HEADER_TYPOGRAPHY, UI_KIT_TEXT_TYPOGRAPHY } from '../../constants';
import { H2, H3 } from '../../header-text/header-text';
import Image from '../../image/image';
import { AnswerStatus } from '../../quiz/typings';
import Text from '../../text/text';

interface Props {
    answerStatus: AnswerStatus;
    name: string;
    questionIndex: number | null;
    questionsCount: number | null;
}

const QuizStudentAnswerStatus = (props: Props) => {
    const { answerStatus, name, questionIndex, questionsCount = 0 } = props;
    const intl = useIntl();

    return (
        <QuizStudentWrapper name={name} theme={answerStatus as QUIZ_STUDENT_THEME}>
            <div className="quiz-student__section">
                {questionIndex !== null && (
                    <div className="quiz-student__question">
                        <Text
                            id="quiz.questionsCounter"
                            typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphLMedium}
                            values={{ index: questionIndex + 1, length: questionsCount }}
                        />
                    </div>
                )}
                <Image
                    alt="answer_status"
                    className="quiz-student__answer-status_image"
                    disableSrcSet={true}
                    src={intl.formatMessage({ id: `quiz.answer.new.image.${answerStatus}.1x` })}
                />
                <H2
                    id={`quiz.answer.status.${answerStatus}.title`}
                    mix="quiz-student__section-title"
                    typography={UI_KIT_HEADER_TYPOGRAPHY.headlineMMedium}
                />
                <H3
                    id={`quiz.answer.status.${answerStatus}.description`}
                    typography={UI_KIT_HEADER_TYPOGRAPHY.headlineXXSRegular}
                />
            </div>
        </QuizStudentWrapper>
    );
};

export default QuizStudentAnswerStatus;
